<template>
  <v-container class="text-center">
    <v-row>
      <img
        :src="image.src"
        :alt="image.alt"
        :width="image.width"
        :height="image.height"
        class="mx-auto"
      />
    </v-row>
    <v-row>
      <v-col>
        <h1
          class="text-center headline-s"
          v-if="title"
          v-i18nHtml="title"
        >
          {{ title }}
        </h1>
        <p
          class="text-center body-l"
          v-if="description"
          v-i18nHtml="description"
        >
          {{ description }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
defineProps<{
  image: {
    src: string;
    alt: string;
    width?: string;
    height?: string;
  };
  title?: string;
  description?: string;
}>();
</script>
